/**
 * フィルタリング
 */
export default class FilterUtil {
  /**
   * ### 検索ワードを配列で返す
   *
   * - 半角スペース、全角スペースは区切り文字として扱う
   * - ""で囲まれたものは完全一致検索として扱い、スペースが含まれていても区切り文字として扱わない
   */
  public createSearchWord(searchWord: string): string[] {
    console.debug("-------------------filterSearchWord() start-------------------");
    console.debug("searchWord:", searchWord);

    const exactMatched: { exactWords: string[]; replacedSearchWord: string } = this.createExactMatching(searchWord);
    const matched: string[] = this.createMatching(exactMatched.replacedSearchWord);

    console.debug("createSearchWord() result:", exactMatched.exactWords.concat(matched));
    console.debug("-------------------filterSearchWord() end-------------------");

    return exactMatched.exactWords.concat(matched);
  }

  /**
   * ### 完全一致対象の文字列配列、完全一致対象を置換した引数文字列を返す
   *
   * - 引数文字列に対して変更は行わない
   * - 完全一致の条件
   *   - 「"」で囲われている文字列
   * - 文字列の中に「"」が複数あり、数が奇数の場合は末尾の「"」は無視する
   *   - 例：「a "b b" " ccc" "d」の場合、dの前の「"」が無視される
   * - 実行結果サンプル
   *   - 引数文字列：a "b b" " ccc" "d
   *   - 完全一致対象の文字列配列：["b b", " ccc"]
   *   - 完全一致対象を置換した引数文字列：a   d
   */
  private createExactMatching(searchWord: string): { exactWords: string[]; replacedSearchWord: string } {
    console.debug("-------------------exactMatching() start-------------------");
    console.debug("searchWord:", searchWord);

    const quotPositions: number[] = [];
    let tempSearchWord: string = searchWord.slice();

    while (tempSearchWord.indexOf('"') != -1) {
      // 2回目以降は文字を削っているので、ベース位置は前の要素の数値+1になる(sliceで「"」を削っているので1文字加算が必要)
      const quotPositionBase: number = quotPositions.length == 0 ? 0 : quotPositions[quotPositions.length - 1] + 1;
      quotPositions.push(tempSearchWord.indexOf('"') + quotPositionBase);
      tempSearchWord = tempSearchWord.slice(tempSearchWord.indexOf('"') + 1);
    }

    // 奇数の場合、末尾の「"」は無視する仕様なので末尾を削除する
    if (quotPositions.length % 2 != 0) {
      quotPositions.pop();
    }

    console.debug("quotPositions:", quotPositions);

    // 完全一致文字列配列を作成する
    const exactWords: string[] = [];
    for (let i = 0; i < quotPositions.length; i = i + 2) {
      // 「"」は除外して検索文字列にしたいので、開始位置は+1して範囲を指定する
      exactWords.push(searchWord.slice(quotPositions[i] + 1, quotPositions[i + 1]));
    }

    // 完全一致で使用した文字列は元の検索文字列から削除する
    let replacedSearchWord: string = searchWord.slice();
    for (const word of exactWords) {
      replacedSearchWord = replacedSearchWord.replace(new RegExp(`"${word}"`, "g"), "");
    }

    console.debug("createExactMatching() result:", { exactWords, replacedSearchWord });
    console.debug("-------------------exactMatching() end-------------------");

    return { exactWords, replacedSearchWord };
  }

  /**
   * ### 検索文字列を返す
   *
   * - 引数文字列に対して変更は行わない
   * - 「"」は文字として扱わない仕様のため、「"」は削除する
   * - 半角または全角スペースを区切り文字とする
   *   - 全角スペースは半角スペース置換して使用する
   * - 区切り文字(半角スペース)単位で文字列を配列化して返す
   *   - 単一の区切り文字の場合は検索文字列として扱わない
   */
  private createMatching(searchWord: string): string[] {
    const tempSearchWord: string = searchWord.slice();
    const quotReplacedWord: string = tempSearchWord.replace(/"/g, "");
    const fullSpaceCharReplacedWord: string = quotReplacedWord.replace(/　/g, " "); // eslint-disable-line
    const searchWords: string[] = fullSpaceCharReplacedWord.split(" ");

    return searchWords.concat().filter((word: string) => {
      if (word == "") {
        return false;
      } else {
        return true;
      }
    });
  }
}
